export default __webpack_public_path__ + "static/media/check-mark@3x.d632c657.png";